<template>
  <BasePageContainer
    class="pt-10">
    <page-header
      has-back
      with-members>
      最終進学先
    </page-header>
    <SectionTitle class="mb-2">
      最終進学先
    </SectionTitle>
    <p class="fs-s pb-2">
      ※決定した進学先を入力・指導者も入力できます
    </p>
    <FinalDestinationForm
      v-if="initialized"
      ref="form"
      :final-destination="finalDestination"
      :api-errors="apiErrors"
      :user="userId"
      @submit="onSubmit" />
  </BasePageContainer>
</template>

<script>
import confirmIfFormChanged from '@/components/mixin/confirmIfFormChanged'
import BasePageContainer from '@/components/parts/BasePageContainer.vue'
import PageHeader from '@/components/parts/PageHeader.vue'
import FinalDestinationForm from '@/components/view/profile/final_destination/FinalDestinationForm.vue'
import SectionTitle from '@/components/view/profile/SectionTitle.vue'
export default {
  components: {
    BasePageContainer,
    PageHeader,
    FinalDestinationForm,
    SectionTitle,
  },
  mixins: [confirmIfFormChanged()],
  data() {
    return {
      finalDestination: null,
      apiErrors: null,
      initialized: false,
    }
  },
  computed: {
    userId() {
      return this.$route.params.id
    },
  },
  created() {
    this.fetchFinalDestination().finally(() => {
      this.initialized = true
    })
  },
  methods: {
    fetchFinalDestination() {
      return this.$axios.get('/profiles/final-destination/', {
        params: {
          user_id: this.$route.params.id,
          limit: 1,
        },
      }).then((res) => {
        this.finalDestination = res.data.results?.[0] || null
      })
    },
    onSubmit(data) {
      // 入力があれば登録、入力がなければ削除する
      const hasDestinationName = data.destinationName.trim() !== ''
      if (hasDestinationName) {
        return this.postFinalDestination(data).then(() => {
          this.$store.commit('notify/set', {message: '最終進学先を登録しました'})
          this.canLeave = true
          this.$nextTick(() => {
            this.$router.push(`/members/${this.$route.params.id}/profile`, { replace: true })
          })
        })
      } else {
        return this.deleteFinalDestination().then(() => {
          this.$store.commit('notify/set', {message: '最終進学先を削除しました'})
          this.canLeave = true
          this.$nextTick(() => {
            this.$router.push(`/members/${this.$route.params.id}/profile`, { replace: true })
          })
        })
      }
    },
    postFinalDestination(data) {
      return this.$axios.post('/profiles/final-destination/', data)
    },
    deleteFinalDestination() {
      return this.$axios.delete(`/profiles/final-destination/${this.finalDestination.id}/`)
    },
  },
}
</script>

<style>

</style>